import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { AlyzeServiceTag } from './AlyzeServiceTag';

const useStyles = makeStyles({
    sectionContainer: {
        alignSelf: 'stretch',
        paddingLeft: '80px',
        paddingRight: '80px',
        backgroundColor: '#F4F0E7',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '48px',
        display: 'flex',
        '@media (max-width: 768px)': {
            paddingLeft: '16px',
            paddingRight: '16px',
            gap: '32px',
        },
    },

    sectionTitle: {
        alignSelf: 'stretch',
        textAlign: 'center',
    },

    titleRegular: {
        color: '#222222',
        fontSize: '64px',
        fontFamily: 'Figtree',
        fontWeight: 400,
        lineHeight: '89.60px',
        wordWrap: 'break-word',
        '@media (max-width: 768px)': {
            fontSize: '32px',
            lineHeight: '44.80px',
        },
    },

    titleItalicGold: {
        color: '#C6A972',
        fontSize: '64px',
        fontFamily: 'Behind The Nineties',
        fontStyle: 'italic',
        fontWeight: 400,
        lineHeight: '89.60px',
        wordWrap: 'break-word',
        '@media (max-width: 768px)': {
            fontSize: '32px',
            lineHeight: '44.80px',
        },
    },

    servicesGrid: {
        alignSelf: 'stretch',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        '@media (max-width: 768px)': {
            gap: '12px',
            justifyContent: 'center',
        },
    },
});

export interface ServiceItem {
    text: string;
    highlighted: boolean;
}

interface AlyzeServiceTagSectionProps {
    title?: string;
    titleItalic?: string;
    services: ServiceItem[];
}

const AlyzeServiceTagSection: React.FC<AlyzeServiceTagSectionProps> = ({
    title = "Celebrity-level care, ",
    titleItalic = "but for you",
    services,
}) => {
    const styles = useStyles();

    return (
        <div className={styles.sectionContainer}>
            <div className={styles.sectionTitle}>
                <span className={styles.titleRegular}>{title}</span>
                <span className={styles.titleItalicGold}>{titleItalic}</span>
            </div>
            <div className={styles.servicesGrid}>
                {services.map((service, index) => (
                    <AlyzeServiceTag 
                        key={index}
                        text={service.text}
                        isBold={service.highlighted}
                    />
                ))}
            </div>
        </div>
    );
};

export { AlyzeServiceTagSection };
